module.exports = __webpack_public_path__ + "img/computer-screenNEW2.e603d072.png";